<template>
  <a-modal
    v-model="cfg.visible"
    :closable="cfg.closable"
    :destroy-on-close="cfg.destroyOnClose === undefined ? true : cfg.destroyOnClose"
    :mask="cfg.mask"
    :mask-closable="cfg.maskClosable === undefined ? false : cfg.maskClosable"
    :keyboard="cfg.keyboard === undefined ? (cfg.closable === undefined ? true : cfg.closable) : cfg.keyboard"
    :title="cfg.title"
    :width="cfg.width"
  >
    <div
      v-if="cfg.waiting"
      class="text-center"
    >
      <a-spin />
    </div>
    <div
      v-else-if="cfg.errorText"
      class="text-center"
    >
      <span class="error-text">{{ cfg.errorText }}</span>
    </div>
    <template v-else>
      <template v-if="$slots.default">
        <slot />
      </template>
    </template>

    <template
      v-if="$slots.footer"
      slot="footer"
    >
      <slot name="footer" />
    </template>
    <template
      v-else-if="cfg.tabCount"
      slot="footer"
    >
      <a-button
        style="float: left"
        @click="handleCancel"
      >
        关闭
      </a-button>
      <a-button
        v-if="showPrev"
        v-show="!cfg.submitting"
        @click="handlePrev"
      >
        上一步
      </a-button>
      <a-button
        v-if="showNext"
        :disabled="cfg.waiting || (cfg.errorText ? true: false)"
        type="primary"
        @click="handleNext"
      >
        下一步
      </a-button>
      <a-button
        v-if="showSubmit"
        :disabled="cfg.waiting || (cfg.errorText ? true: false)"
        :loading="cfg.submitting"
        type="primary"
        @click="handleOk"
      >
        {{ cfg.submitting ? (cfg.submittingText || '提交中') : (cfg.okText || '确定') }}
      </a-button>
    </template>
    <template
      v-else
      slot="footer"
    >
      <a-button
        v-if="cfg.closable === undefined ? true : cfg.closable"
        @click="handleCancel"
      >
        关闭
      </a-button>

      <a-button
        v-if="!cfg.readonly"
        :disabled="cfg.waiting || (!!cfg.errorText)"
        :loading="cfg.submitting"
        type="primary"
        @click="handleOk"
      >
        {{ cfg.submitting ? (cfg.submittingText || '提交中') : (cfg.okText || '确定') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'Modalx',
  props: {
    cfg: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    showPrev () {
      return this.cfg.tabIndex > 0
    },
    showNext () {
      return this.cfg.tabIndex >= 0 && this.cfg.tabIndex < this.cfg.tabCount - 1
    },
    showSubmit () {
      return this.cfg.tabIndex === this.cfg.tabCount - 1
    }
  },
  watch: {
    'cfg.visible': (val) => {
      setTimeout(() => {
        if (val) {
          const triggerDom = document.querySelector('.ant-modal-header')
          triggerDom.style.cursor = 'move'
          const bodyDom = document.querySelector('.ant-modal')

          let canMove = false
          let clientX = 0
          let clientY = 0
          const initBodyInfo = {}
          const handleMousedown = (e) => {
            ({ clientX, clientY } = e)
            canMove = true
            if (!initBodyInfo.defaultTop) initBodyInfo.defaultTop = bodyDom.offsetTop
            if (!initBodyInfo.defaultLeft) initBodyInfo.defaultLeft = bodyDom.offsetLeft

            bodyDom.style.left = `${bodyDom.offsetLeft}px`
            bodyDom.style.top = `${bodyDom.offsetTop}px`
            bodyDom.style.position = 'absolute'
          }
          const handleMousemove = (e) => {
            if (!canMove) return
            if (canMove) {
              bodyDom.style.left = `${initBodyInfo.defaultLeft + e.clientX - clientX}px`
              bodyDom.style.top = `${initBodyInfo.defaultTop + e.clientY - clientY}px`
            }
          }
          const handleMouseup = () => {
            if (initBodyInfo.defaultTop) initBodyInfo.defaultTop = parseFloat(bodyDom.style.top.replace('px', ''))
            if (initBodyInfo.defaultLeft) initBodyInfo.defaultLeft = parseFloat(bodyDom.style.left.replace('px', ''))
            canMove = false
          }

          if (document.addEventListener) {
            triggerDom.addEventListener('mousedown', handleMousedown)
          } else {
            triggerDom.attachEvent('onmousedown', handleMousedown)
          }

          if (document.addEventListener) {
            document.addEventListener('mousemove', handleMousemove)
          } else {
            document.attachEvent('onmousemove', handleMousemove)
          }

          if (document.addEventListener) {
            document.addEventListener('mouseup', handleMouseup)
          } else {
            document.attachEvent('onmouseup', handleMouseup)
          }
        }
      }, 400)
    }
  },
  methods: {
    handleOk () {
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
      this.cfg.visible = false
    },
    handleNext () {
      this.$emit('tab-change', this.cfg.tabIndex + 1)
    },
    handlePrev () {
      this.$emit('tab-change', this.cfg.tabIndex - 1)
    }
  }
}
</script>

<style scoped>

</style>
